// The section form's rules (course view → New Section / Edit section).
//
// Create: an English title and an English description of 3+ characters.
// Edit: a section saved before these rules (no description, a two-letter
// title) must still be renamable, so the 3-character rules apply only to the
// fields the admin changes (as the course form, plan R1 C4), and a description
// may be cleared. The API needs only a non-empty title (admin-section.dto.ts).
import * as Yup from 'yup';
import { Section } from 'src/@types/Course';

export type SectionFormValues = Pick<Section, 'title' | 'title_ar' | 'description' | 'description_ar'>;

export const SECTION_TITLE_REQUIRED_TEXT = 'Section title is required';
export const SECTION_TITLE_MIN_TEXT = 'title must be at least 3 characters';
export const SECTION_DESCRIPTION_REQUIRED_TEXT = 'description is Required';
export const SECTION_DESCRIPTION_MIN_TEXT = 'description must be at least 3 characters';

const atLeast3 = (value?: string) => (value ?? '').trim().length >= 3;

export function sectionSchema(isEdit: boolean, initial: Partial<SectionFormValues> = {}) {
  if (!isEdit) {
    return Yup.object().shape({
      title: Yup.string().min(3).required(SECTION_TITLE_REQUIRED_TEXT),
      description: Yup.string().min(3).required(SECTION_DESCRIPTION_REQUIRED_TEXT),
    });
  }
  const unchanged = (key: 'title' | 'description', value?: string) =>
    (value ?? '') === (initial[key] ?? '');
  return Yup.object().shape({
    title: Yup.string()
      .required(SECTION_TITLE_REQUIRED_TEXT)
      .test('min3-if-changed', SECTION_TITLE_MIN_TEXT, (v) => unchanged('title', v) || atLeast3(v)),
    description: Yup.string().test(
      'min3-if-changed',
      SECTION_DESCRIPTION_MIN_TEXT,
      (v) => unchanged('description', v) || !(v ?? '').trim() || atLeast3(v)
    ),
  });
}
